import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from "../../../config/employeeApiConfig";

//fetch workforceData
export const fetchWorkforceData = createAsyncThunk(
  'hrDashboard/fetchWorkforceData',
  async (
    { hrId, year, month }: { hrId?: number; year?: number; month?: number } = {},
    { rejectWithValue }
  ) => {
    try {
      // Build query params dynamically
      const queryParams: string[] = [];
      if (year) queryParams.push(`year=${year}`);
      if (month) queryParams.push(`month=${month}`);
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

      const response = await employeeServiceApiInstance.get(
        `/hr-dashboard/workforce/${hrId || ''}${queryString}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch workforce data'
      );
    }
  }
);

//filter monthwise data
export const fetchMonthlySummaryForWorkforce = createAsyncThunk(
  'hrDashboard/fetchHRWiseMonthlySummary',
  async (
    { hrId, year, month }: { hrId: number; year?: number; month?: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(`/workforce/hr-summary/${hrId}/${year}/${month}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch workforce data');
    }
  }
);

export const fetchAttendanceData = createAsyncThunk(
  'hrDashboard/fetchAttendanceData',
  async ({ hrId }: { hrId?: number } = {}, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/hr-dashboard/attendance/${hrId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch attendance data');
    }
  },
);
export const fetchCompensationData = createAsyncThunk(
  'hrDashboard/fetchCompensationData',
  async ({ hrId, year, month }: { hrId?: number; year?: number; month?: number } = {}, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/hr-dashboard/compensation/${hrId}/${year}/${month}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch compensation data');
    }
  },
);
export const fetchResignationData = createAsyncThunk(
  'hrDashboard/fetchResignationData',
  async ({ hrId }: { hrId?: number } = {}, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/hr-dashboard/resignation/${hrId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch resignation data');
    }
  },
);

export const fetchHRwiseWorkforceEmployees = createAsyncThunk(
  'hrDashboard/fetchHRwiseWorkforceEmployees',
  async ({ hrId }: { hrId?: number } = {}, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/hr/workforce/employeeDetails/${hrId}`);
      console.log(response.data, 'respone from slice')
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch HR workforce details');
    }
  }
);

export const fetchHRwiseAttendanceDetails = createAsyncThunk(
  'hrDashboard/fetchHRwiseAttendanceDetails',
  async ({ hrId }: { hrId?: number } = {}, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/hr/attendance/employeeDetails/${hrId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch HR attendance details');
    }
  }
);


